import { Button, Dialog, Text, VSpacer } from '@/components/DesignSystem';
import { ApiRetailerLocation, ApiUser } from '@api/interfaces';
import { Divider } from '@mui/material';
import { getAccountName } from '@shared/utilities';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface LocationsDialogProps {
  accountGroupId?: string,
  customer: ApiUser,
  locations: ApiRetailerLocation[],
  onClose: () => void,
}

export const LocationsDialog = ({
  accountGroupId,
  customer,
  locations,
  onClose,
}: LocationsDialogProps) => {
  const sortedLocations = locations.sort((a, b) => a.name.localeCompare(b.name));
  const { t } = useTranslation();
  const subtitle = accountGroupId
    ? t($ => $.overview.locationsDialog.accountGroupSubtitle, { accountGroupId })
    : t($ => $.overview.locationsDialog.subtitle, { customerName: getAccountName(customer) });
  return (
    <Dialog
      acceptButton={(props) => (
        <Button
          {...props}
          onClick={onClose}
          testID="close-locations-dialog-button"
          variant="contained"
        >
          {t($ => $.common.actions.close)}
        </Button>
      )}
      onClose={onClose}
      open
      showCloseButton={false}
      subtitle={subtitle}
      testID="linked-accounts-dialog"
      title={t($ => $.overview.locationsDialog.title)}
    >
      {sortedLocations.map((location) => (
        <Fragment key={location.id}>
          <VSpacer size="4" />
          <Text category="label-large">
            {location.name}
          </Text>
          <VSpacer size="4" />
          <Divider />
        </Fragment>
      ))}
    </Dialog>
  );
};
